<template>
  <div>
    <stock :searchObj="searchObj" :stockTypeObj="stockTypeObj" ref="stock" @postListData="postListData" @toBudgetData="toBudgetData">
      <template v-slot:searchDiv>
        <div class="secondSearchLine">
          <el-date-picker style="width: 2.7rem" key="hotel" class="dateBox" value-format="yyyy-MM-dd" size="mini" v-model="searchObj.date"
            type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span class="date">{{ getBetweenDay(searchObj.date) }}晚</span>
          <el-select v-model="searchObj.star" :popper-append-to-body="false" size="mini">
            <el-option v-for="item in hoteloptionsOne" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="searchObj.location" :popper-append-to-body="false" size="mini">
            <el-option v-for="item in hoteloptionsTwo" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="searchObj.searchHotelPrice" :popper-append-to-body="false" size="mini">
            <el-option v-for="item in hoteloptionsThree" :key="item.value" :label="item.label" :value="item.value">\</el-option>
          </el-select>
        </div>
      </template>
      <template v-slot:contentDiv>
        <div v-for="(item,index) in dataList" :key="index">
          <custom v-if="item.productType==1" :item="item" :chenckBudgteObj="$refs.stock.budget" :keyStr="keyStr" class="contentDiv"></custom>
          <div v-else-if="item.productType==2">
            <exclusive-stock :keyStr="keyStr" :productObj="item"></exclusive-stock>
          </div>
          <div v-else class="contentDiv">
            <hotel-resource-left :productObj="item" :showTag="false" @getHotelPriceInfo="getHotelPriceInfo" :rightShowStyle="2"
              :btnName="'酒店直采特价'" class="contentHead" :budget="budget" @resourceInfo="resourceInfo(item,index)"></hotel-resource-left>
            <div @click.stop class="contentContainer" v-if="item.isOpen">
  <!--            <p style="text-align: center; font-size: 20px" v-show="item.isLoading && item.productType === 9">-->
              <p style="text-align: center; font-size: 20px" v-show="item.isLoading">
                <i class="el-icon-loading"></i>
              </p>
              <div @click.stop class="boxContainer1" v-for="(item1, index1) in item.stockListResults" :key="index1">
                <div class="firstLine">
                  <div class="item" @click="showRoomInfo(item1,index1)">
                    <el-tooltip :content="item1.productNameCn">
                      <b :title="item1.productNameCn" class="productName">{{ item1.productNameCn }}</b>
                    </el-tooltip>
                  </div>
                  <div>
                    <div class="item1" v-for="(item2,index2) in item1.priceList" :key="index2">
                      <span style="font-size: 0.13rem;">{{ item2.startDate}}&nbsp;至&nbsp;{{item2.endDate}}</span>
                      <span>&nbsp;{{ getBetweenDay([item2.startDate,item2.endDate])}}晚&nbsp;</span>
                      <div class="item2">
                        <el-popover placement="top" trigger="hover">
                          <template>
                            <div class="night-price">
                              <p>客房每日价格</p>
                              <ul class="night-list-one">
                                <li>日期</li>
                                <li>房价/间/晚</li>
                              </ul>
                              <ul  class="night-list-two" v-for="(i, n) in item2.dates" :key="n">
                                <li>{{ i.date }}</li>
                                <li style="color: #ff5256">
                                  {{ i.currency }}{{ i.price }}
                                </li>
                              </ul>
                            </div>
                          </template>
                          <span slot="reference" class="tag hoverClick" @click="addRefreBudget(item,item1,item2)"><span style="font-size:0.15rem">均价</span>{{ item2.price }}{{ item2.currency }}</span>
                        </el-popover>
                        <div class="tagBox">
                          <el-input v-model="item1.checkNumber" style="width: 60px" size="mini"></el-input>
                          <span>&nbsp;间</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item3">
                    <span class="qiang" >抢</span>
                    <i class="el-icon-circle-plus-outline" @click="addBudget(item,item1)"></i>
                  </div>
                </div>
                <div class="firstLine">
                  <div class="item"></div>
                  <div class="item1">
                    <span v-if="item.productType==3" style="color: #db4e1a;">{{ item1.cancelType==1?'不可取消':'有条件取消' }}</span>
                    <span v-else style="color: #db4e1a;">{{ item1.cancelType}}</span>
                    <span style="font-weight: normal;">&nbsp;{{ item1.stockDesc }}</span>
                  </div>
                  <div class="item3">
                    <b slot="reference" style="color: #db4e1a;" class="hoverClick" >说明</b>
                  </div>
                </div>
              </div>
              <p style="text-align: right">
                <i class="el-icon-caret-top" @click.stop="item.isOpen = false"></i>
              </p>
            </div>
          </div>
        </div>
      </template>
    </stock>
    <create-refer-product-dialog ref="createProduct" :keyStr="keyStr" :climbKey="climbKey"></create-refer-product-dialog>
    <stockDetail ref="hotelResourceInfo"></stockDetail>
    <HotelProductInfo ref="ProductInfo"></HotelProductInfo>
  </div>
</template>

<script>
import Stock from './stock.vue'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import Api from '@/components/Api/index.js'
import { refresh } from '../../js/function'
import Custom from './custom.vue'
import ExclusiveStock from './exclusiveStock.vue'
import stockDetail from "@/views/plan/info/ResourceDetail.vue";
import HotelProductInfo from "@/views/plan/info/product/HotelProductInfo.vue";
import createReferProductDialog from "./addProductDialog/createReferProductDialog.vue"
export default {
  components:{Stock,hotelResourceLeft,Custom, ExclusiveStock,stockDetail,HotelProductInfo,createReferProductDialog},
  data(){
    return{
      searchObj:{
        cityId:null,
        cityName:null,
        cityNameCn:null,
        cityNameEn:null,
        countryId:null,
        date:[],
        star:null,
        location:null,
        searchHotelPrice:null,
        keyword:null,
        productType:0,
        state:0,
      },
      hoteloptionsOne: [
        {
          value: null,
          label: "不限星级",
        },
        {
          value: 3,
          label: "三星酒店",
        },
        {
          value: 4,
          label: "四星酒店",
        },
        {
          value: 5,
          label: "五星酒店",
        },
      ],
      hoteloptionsTwo: [
        {
          value: 0,
          label: "不限位置",
        },
        {
          value: 1,
          label: "市中心",
        },
        {
          value: 2,
          label: "市区",
        },
        {
          value: 3,
          label: "市郊",
        },
        {
          value: 4,
          label: "郊区",
        },
      ],
      hoteloptionsThree: [
        {
          value: "",
          label: "不限价格",
        },
        {
          value: "3",
          label: "200 - 400",
        },
        {
          value: "4",
          label: "400 - 500",
        },
        {
          value: "5",
          label: "500 - 600",
        },
      ],
      dataList:[],
      climbSelf : false,
      climbKey:'',
      mySelf:false,
      keyStr:'',
      budget:null,
    }
  },
  props:{
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
    checkState:{
      type:Number,
      default:0,
    }
  },
  methods:{
    addRefreBudget(item,item1,item2){
      this.$refs.createProduct.beforeOpen(item,[item1],this.$refs.stock.budget)
    },
    toBudgetData(budget){
      this.budget = budget
    },
    showRoomInfo(roomInfo,index) {
      this.$refs.ProductInfo.init(roomInfo.roomInfo)
    },
    resourceInfo(item,index) {
      this.$refs.hotelResourceInfo.init(item,"");
    },
    climbStockList(){
      if(!this.$refs.stock.loading){
        this.$refs.stock.loading = true
        var stock = JSON.parse(JSON.stringify(this.searchObj))
        if(!(this.searchObj.keyword&&this.searchObj.keyword!='')){
          stock.keyword = this.searchObj.cityNameCn
        }
        stock.key = this.climbKey;
        new Api('resource').climbStockList({page:this.$refs.stock.page,size:10,q:stock}).then(res => {
          this.$refs.stock.loading = false
          if (res.status == 200) {
            if(res.data.length==0) this.climbSelf = true;
            if(this.$refs.stock.mySelf&&this.climbSelf) this.$refs.stock.isMore = true
            res.data.forEach(element => {
              this.$set(element,'isOpen',false)
              // element.productType=6
            });
            res.data.forEach(element => {
              this.dataList.push(element)
            });
            this.$refs.stock.sortArr(this.dataList)
            this.climbKey = res.key
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        }).catch(er=>{
          this.$refs.stock.loading = false
        })
      }
    },
    postListData(type){
      if(this.checkState===0){
        if(type=='empty'){
          this.dataList =[]
          this.mySelf = false
          this.climbSelf = false
          this.keyStr=''
          this.climbKey=''
        }
        this.searchObj.startDate = this.searchObj.date[0];
        this.searchObj.endDate = this.searchObj.date[1];
        this.searchObj.key = this.keyStr;
        if(!this.climbSelf){
          this.climbStockList()
        }
        if(!this.mySelf){
          new Api('resource').rightStockList({page:this.$refs.stock.page,size:10,q:this.searchObj}).then(res => {
            if (res.status == 200) {
              if(res.data.length<10) this.mySelf = true;
              if(this.mySelf&&this.climbSelf) this.$refs.stock.isMore = true
              this.$refs.stock.getDateList(res.data)
              res.data.forEach(element => {
                this.dataList.push(element)
              });
              this.keyStr = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }
      }
    },
    getHotelPriceInfo(val){
      val.isLoading = true;
      var obj = {
        startDate:this.searchObj.startDate,
        endDate:this.searchObj.endDate,
        keyword:val.id,
        key:this.climbKey,
      }
      new Api('resource').climbStockDetail(obj).then(res => {
        val.isLoading = false
        if (res.status == 200) {
          res.data.forEach(item=>{
            this.$set(item,"checkNumber",this.$refs.stock.budget.useNumber)
          })
          this.$set(val,"stockListResults",res.data)
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      }).catch(er=>{})
    },
    addBudget(item,item1){
      var arr = [{
        stockId:item1.stockId,
        stockNumber:item1.checkNumber
      }]
      var obj = {
        budgetMainId:this.$store.state.budgetMainId,
        planId:this.$store.state.planId,
        state:0,
        startLinkId:item.productType==3?item.cityId:this.searchObj.cityId,
        startLinkName:item.productType==3?item.cityNameCn:this.searchObj.cityNameCn,
        startLinkNameEn:item.productType==3?item.cityName:this.searchObj.cityNameEn,
        linkType:1,
        productType:item.productType,
        resourceId:item.id,
        resourceNameCn:item.nameCn,
        resourceNameEn:item.nameEn,
        key:item.productType==3?this.keyStr:this.climbKey,
        details:arr
      }
      new PlanApi('plan').budgetAdd(obj).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"添加成功"})
          refresh(res.data,this.$store.state.planId,this.$store.state.budgetMainId)
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.secondSearchLine{
  /deep/ .el-range-separator{
    transform: translateX(-4px);
  }
  .date{
    margin-left: 0.1rem;
  }
  /deep/ .el-select{
    margin-left: 0.1rem;
    width: 1rem;
  }
}
.contentDiv{
  border-radius: 12px 12px 0 0;
  border: 1px solid #db4e1a;
  padding-top: 0.1rem;
  margin-bottom: 0.07rem;
  .contentHead{
    border-bottom: 3px solid #db4e1a;
    .head_left{    
      /deep/ .showCard-imgBox{
        margin-left: 0;
        img{
          margin: 0 0.05rem;
        }
      }
    }
  }
  .contentContainer{
    .boxContainer1{
      font-size: 0.12rem;
      margin-top: 0.1rem;
      margin-left: 0.1rem;    
      padding-right: 0.1rem;
      .firstLine{
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.05rem;
        .item{
          width: 1.4rem;
          .productName{
            font-size: 0.125rem;
            width: 1.4rem;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .item1{
          margin-left: 0.1rem;
          display: flex;
          align-items: center;
          width: 4.6rem;
          margin-bottom: 0.05rem;
          .item2{
            display: flex;
            align-items: center;
            >span{
              color: #ff0000;
              font-size: 0.16rem;
              text-decoration: underline;
              width: 1rem;
            }
          }
          .tagBox{
            >span{
              font-size: 0.14rem;
              font-weight: normal;
            }
          }
        }
        .item3{
          display: flex;
          width: 0.6rem;
          .qiang{
            font-size: 0.18rem;
            box-shadow: 0px 0px 4px 0px #333;
            border-radius: 50%;
            color: red;
            text-align: center;
            display: inline-block;
            width: 0.26rem;
            height: 0.26rem;
            line-height: 0.26rem;
            margin: 1px;
            vertical-align: middle;
            margin-right: 0.05rem;
          }
          >i{
            font-size: 0.28rem;
          }
        }
      }
    }
    >p{
      >i{
        font-size: 0.25rem;
      }
    } 
  }
}
</style>